import script from "./StudioProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioProjects.vue?vue&type=script&setup=true&lang=js"

import "./StudioProjects.vue?vue&type=style&index=0&id=5487703c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5487703c"]])

export default __exports__